<template>
    <loading name="load page">
        <div class="container profile fix-footer">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card mt-5">
                        <div class="card-header">
                            <h3>{{ $t('pages.UserProfile') }}</h3>
                        </div>
                        <div class="card-body">
                            <h3>{{ $t('fieldSections.PersonalInformation') }}</h3>
                            <hr>
                            <div class="row">
                                <div class="form-group col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="control-label"> {{ $t('fields.FirstName') }} </label>
                                        <div>
                                            <span>{{ info.profile.first_name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="control-label">{{ $t('fields.LastName') }}</label>
                                        <div>
                                            <span>{{ info.profile.last_name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="control-label">{{ $t('fields.Nick') }}</label>
                                        <div>
                                            <span>{{ info.profile.nick }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="control-label">{{ $t('fields.PhoneNumber') }}</label>
                                        <div>
                                            <span>{{ info.profile.phone }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="control-label">{{ $t('fields.City') }}</label>
                                        <div>
                                            <span>{{ info.profile.city }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-6">
                                    <label class="control-label">{{$t('fields.Email') }}</label>
                                    <div>
                                        <span>{{ info.email }}</span>
                                    </div>
                                </div>
                                <div class="col-3 col-md-2">
                                    <label class="control-label">{{$t('fields.Avatar') }}</label>

                                    <div class="thumbnail" v-if="info.avatar">
                                        <img :src="info.avatar" class="img-thumbnail rounded-circle">
                                    </div>
                                    <h2 class="fa fa-user-circle" v-else></h2>
                                </div>
                                <div class="text-right col-12 mt-3">
                                    <edit-password class="mr-3"></edit-password>
                                    <edit-personal-info
                                            :lastName="info.profile.last_name"
                                            :city="info.profile.city"
                                            :phone="info.profile.phone"
                                            :avatar="info.avatar"
                                            :email="info.email"
                                            :nick="info.profile.nick"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import EditPassword from '../../components/profile/EditPassword';
  import EditPersonalInfo from '../../components/profile/EditPersonalInfo';

  export default {
    name: 'Profile',
    components: {
      EditPassword,
      EditPersonalInfo
    },
    computed: {
      info() {
        return this.$store.state.user.info;
      }
    }
  };
</script>

<style scoped>

</style>
